import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const ResumeTrackerService = {
  getDashboard: async (dateFrom, dateTo, page = 1, pageSize = 10) => {
    const endpoint = createEndpoint(API_ENDPOINTS.RESUME_TRACKER.DASHBOARD, {
      date_from: dateFrom,
      date_to: dateTo,
      page,
      pageSize,
    });
    const response = await api.get(endpoint);
    return response;
  },
  getJobCandidates: async (
    jobRef,
    { dateFrom, dateTo, status, page = 1, pageSize = 10 }
  ) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.RESUME_TRACKER.JOB_CANDIDATES,
      { jobRef, date_from: dateFrom, date_to: dateTo, status, page, pageSize }
    );
    const response = await api.get(endpoint);
    return response;
  },
};
